module.exports = __webpack_public_path__ + "static/d0755079-9a57-478b-a15d-5752ba46bd69-500.8d4fcc02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-michael-and-all-angels/d0755079-9a57-478b-a15d-5752ba46bd69-500.jpg
// module id = 1176
// module chunks = 168707334958949